import * as types from '../mutation-types'
import Vapi from 'vuex-rest-api'
import merge from 'lodash/merge'
import Vue from 'vue'

const module = new Vapi({
  baseURL: Vue.$backendBaseURL,
  state: {
    all: [
      {
        name: 'tourDashboard',
        viewed: true
      },
      {
        name: 'tourOrg',
        viewed: true
      },
      {
        name: 'tourSuscribers',
        viewed: true
      },
      {
        name: 'tourUpload',
        viewed: true
      },
      {
        name: 'tourImport',
        viewed: true
      },
      {
        name: 'tourCampaign',
        viewed: true
      },
      {
        name: 'tourStep1',
        viewed: true
      },
      {
        name: 'tourStep2',
        viewed: true
      },
      {
        name: 'tourStep3',
        viewed: true
      },
      {
        name: 'tourStep4',
        viewed: true
      },
      {
        name: 'tourUsers',
        viewed: true
      }
    ],
    current: {
      name: '',
      data: null,
      viewed: true
    },
    activeHelp: false
  }
})
.getStore()

const state = {
}

const getters = {
  getTourByName (state) {
    return function (name) {
      return state.all.find(item => item.name === name)
    }
  },
  setViewedOff (state) {
    return function (name) {
      return state.all.find(item => item.name === name)
    }
  }
}

const actions = {
}

const mutations = {
  [types.RESET_TOUR_STATE] (state) {
    state.current = null
  },

  [types.UPDATE_CURRENT_TOUR] (state, { tour }) {
    state.current = tour
  },

  [types.SET_VIEWED_VALUE] (state, value) {
    const result = state.all.find(item => item.name === value)
    result.viewed = true
  },

  [types.CHANGE_ACTIVE_HELP] (state, value) {
    state.activeHelp = value
  },

  [types.UPDATE_CURRENT_TOUR_DATA] (state, value) {
    state.current = { data: value }
  }
}

export default merge(module, {
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/modules/tour.js